import { useRef } from 'react';

import { notificationQueryKeys, type Notification } from '@/entities/notification';

import {
  useBatchedOptimisticAction,
  type UseBatchedOptimisticActionOptions
} from '@/shared/lib/hooks/use-batched-optimistic-action';

type NotificationBatchedAction = Omit<UseBatchedOptimisticActionOptions<Notification>, 'queryKey'>;

export const useNotificationBatchedAction = (options: NotificationBatchedAction) => {
  const notificationQueryKey = useRef(notificationQueryKeys.lists());

  return useBatchedOptimisticAction<Notification>({
    ...options,
    queryKey: notificationQueryKey.current
  });
};
